function openFancybox(target) {
  $.fancybox.open({
    src: target,
    type: 'inline',
    helpers: {
      overlay: {
        locked: false
      }
    },
    opts: {
      afterShow: function (instance, current) {
        $("#scroll-top").trigger();
      }
    }
  });
}

$(".vwodetails").on('click', function () {
  openFancybox('#vwodetails');
});

$(".fda").on('click', function () {
  openFancybox('#fda');
});

$(".customized-teeth").on('click', function () {
  openFancybox('#customized-teeth');
});

$(".micro-adjustments").on('click', function () {
  openFancybox('#micro-adjustments');
});

$(".money-back-details").on('click', function () {
  openFancybox('#money-back-details');
});

$(".faqdetails").on('click', function () {
  openFancybox('#faqdetails');
});

$(".fda-cleared").on('click', function () {
  openFancybox('#fda-cleared');
});

// $("header #menu-icon").on("click", function() {
// 	return $(".navbar").toggleClass("expand"),$("body").toggleClass("expand"),!1
  
// });

// $('body').click(function(){
//     $(".navbar").removeClass("expand");
//     $(this).removeClass("expand");
// });

$(".question_block .footer_chatbtn").on("click", function() {
	$(this).parents().find('#rp-home').trigger('click');
});

$(".play").click(function (e) {
	e.preventDefault();
	var mediaVideos = $("video");
	mediaVideos.each(function () {
		var mediaVideo = this;
		mediaVideo.pause();
		$(".play").addClass("active").show();
	});

	var videoparent = $(this);
	setTimeout(function () {
		$(videoparent).parent().find("video").get(0).play();
	}, 500);

	$(this).hide();
});

$(".single_faq h4").on("click", function() {
		$(this).next().slideToggle(), $(this).find("i").hasClass("fa-angle-right") ? ($(this).find("i").removeClass("fa-angle-right"), $(this).find("i").addClass("fa-angle-down")) : ($(this).find("i").removeClass("fa-angle-down"), $(this).find("i").addClass("fa-angle-right"))
}), $("input.first").on("change", function() {
		$(this).is(":checked") && ($("select.second").slideUp(), $("select.first").slideDown())
}), $("input.second").on("change", function() {
		$(this).is(":checked") && ($("select.second").slideDown(), $("select.first").slideUp())
}), $(".faq-accordian li a").on("click", function() {
		$(".faq-accordian li a").removeClass("active"), $(".faq-content").hide(400), $(this).toggleClass("active"), $(this).next(".faq-content").toggle(400)
}), $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(t) {
		var s;
		location.pathname.replace(/^\//, "") != this.pathname.replace(/^\//, "") || location.hostname != this.hostname || (s = (s = $(this.hash)).length ? s : $("[name=" + this.hash.slice(1) + "]")).length && (t.preventDefault(), $("html, body").animate({
				scrollTop: s.offset().top
		}, 1e3, function() {
				var t = $(s);
				if (t.focus(), t.is(":focus")) return !1;
				t.attr("tabindex", "-1"), t.focus()
		}))
})


var $iframeVideo = $('iframe[data-src*="youtube.com/embed"], iframe[data-src*="player.vimeo"], iframe[data-src*="fastly.net"]');
$iframeVideo.each(function () {
	// Add wrapper to make video responsive
	if(!$(this).parent().hasClass('video-wrapper')){
		$(this).wrap('<div class="video-wrapper"></div>');
	}
});

$(".cartqua button.js-qty__adjust.js-qty__adjust--plus").on("click", function() {
	var t = $(this).siblings("input").val(),
	s = parseInt(t) + parseInt(1);
	$(this).siblings("input").val(s);
	var n = $(this).attr("data-varid");
		n = parseInt(n),$.ajax({
		type: 'POST',
		url: '/cart/change.js',
		data: 'quantity=' + s + '&id=' + n,
		dataType: 'json',
		success: function(cart) {
				location.reload();
		},
	})
});

$(".cartqua button.js-qty__adjust.js-qty__adjust--minus").on("click", function() {
	var t, s, n = $(this).siblings("input").val();
	n < 1 || 
	(
		t = parseInt(n) - parseInt(1), $(this).siblings("input").val(t), s = $(this).attr("data-varid"), s = parseInt(s), console.log(s), $.ajax({
			type: 'POST',
			url: '/cart/change.js',
			data: 'quantity=' + t + '&id=' + s,
			dataType: 'json',
			success: function(cart) {
				location.reload();
			},
		})
	)
});

let f = 21;
$(".review-main .review-content:lt(" + f + ")").show().addClass("new"),
$(document).on("click", "#loadMore", function(s) {
		s.preventDefault(),
		(f += 40) <= 500 && $(".review-main .review-content:lt(" + f + ")").show().addClass("new")
}),
$(window).trigger("resize");


$(document).on('click','.vwoclose',function(e){
	e.preventDefault();
	$('[data-fancybox-close]').click();
});

$(document).on('click','.review-widget-click',function(e){
    $('html, body').animate({
        scrollTop: $(".okeReviews-widget-holder").offset().top
    }, 2000);
});

$(document).on('click','.template-product .buy_btn_block .buy_btn,.template-product .multicolumn a:not(.cm_play,.underlined-link),.template-product .satisfaction_section .cm_btn a,.template-product .customer_service_wrapper a,.template-product .back_to_top',function(e){
    e.preventDefault(); 
    window.scrollTo(0, 0);
});

//  $(document).ready(function () {
//   var viewportWidth = $(window).width();
//   if (viewportWidth < 768) { 
//     $('.mobile_announcement_bar').slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         dots: false,
//         arrows: true,
//         infinite: true,
//         prevArrow:'<button class="slide-arrow prev-arrow"><i class="fa fa-angle-left"></i></button>',
//         nextArrow:'<button class="slide-arrow next-arrow"><i class="fa fa-angle-right"></i></button>'
//     });
//   }
// });


// announcement bar slider 
// var slickInstance; // Declare a global variable to store the Slick instance

// function handleViewportWidth() {
//     var viewportWidth = $(window).width();
    
//     // Check if Slick has been initialized and destroy it if it has
//     if (slickInstance && viewportWidth >= 768) {
//         $('.mobile_announcement_bar').slick('unslick');
//         slickInstance = undefined; // Reset the Slick instance variable
//     }

//     // Initialize Slick if the viewport width is less than 768 pixels
//     if (viewportWidth < 768 && !slickInstance) { 
//         $('.mobile_announcement_bar').slick({
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             dots: false,
//             arrows: true,
//             infinite: true,
//             prevArrow:'<button class="slide-arrow prev-arrow"><i class="fa fa-angle-left"></i></button>',
//             nextArrow:'<button class="slide-arrow next-arrow"><i class="fa fa-angle-right"></i></button>'
//         });
//         slickInstance = true; // Set the Slick instance variable to true
//     }
// }

// // Call the function on load
// $(document).ready(function() {
//     handleViewportWidth();
// });

// // Call the function on window resize
// $(window).on('resize', function() {
//     handleViewportWidth();
// });

// scroll to top button start
document.addEventListener("DOMContentLoaded", function() {
  var scrollToTopButton = document.getElementById("scroll-to-top-button");
  if(scrollToTopButton){
  // Calculate 35% of the page height
  var scrollThreshold = 0.35 * (document.documentElement.scrollHeight - window.innerHeight);
  // Show/hide the button based on scroll position
  window.addEventListener("scroll", function() {
    if (document.body.scrollTop > scrollThreshold || document.documentElement.scrollTop > scrollThreshold) {
      scrollToTopButton.style.display = "block";
    } else {
      scrollToTopButton.style.display = "none";
    }
  });
  // Scroll to the top when the button is clicked
  scrollToTopButton.addEventListener("click", function () {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  });
}
});


// scroll to top button end

$(document).on('click','.pack-infomation',function(){
  $('.pack_wrapper').removeClass('active');
  $(this).closest('.pack_wrapper').addClass('active');
});
$(document).on('click','.variant-box',function(){
  $(this).closest('.pack_variant-list').find('.variant-box').removeClass('active');
  $(this).addClass('active');
});

function addBundleToCart(formData) {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    window.SLIDECART_UPDATE(data);
    window.SLIDECART_OPEN()
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Call the addToCart function to add products to the cart
$(document).on('click','.bundle-add-to-cart',function(e){
  e.preventDefault();
  fetch('/cart.js', { method: "GET" })
  .then(async (res) => {
    window.cart_response = await res.json();
    window.__added_variant_ids = window.cart_response['items'].map(x => x['id']);
    
    var items = [];
    $(".pack_wrapper.active .variant-box.active").each(function() {
      var data = {};
      var id = $(this).data('variant-id');
      data.id = id;
      data.quantity = 1;
      if (!window.__added_variant_ids.includes(+id)) {
        items.push(data);
      }
    });
    
    if (items.length > 0) {
      if (typeof window.SLIDECART_STATE === 'function') {
        let formData = { items }
        addBundleToCart(formData);
      }
    } else {
      window.SLIDECART_OPEN();
    }
  });
}); 

  $(document).ready(function() {
    console.log("Script executed");

    // Check if the current URL contains 'home-1'
    if (window.location.pathname.includes('home-1')) {
function isTablet() {
    const userAgent = navigator.userAgent.toLowerCase();

    const tabletDevices = [
        'ipad',      // Apple iPads
        'android',   // Android tablets
        'silk',      // Kindle Fire
        'playbook',  // BlackBerry PlayBook
        'tablet',    // General tablet keyword
        'nexus 7',   // Nexus 7 tablet
        'nexus 10',  // Nexus 10 tablet
        'kfapwi',    // Kindle Fire HDX
    ];

    const isNotPhone = !/mobile/.test(userAgent);

    return $.grep(tabletDevices, function (device) {
        return userAgent.includes(device);
    }).length > 0 && isNotPhone;
    }

    if (isTablet()) {
        console.log('User is on a tablet');
    } else {
        console.log('User is not on a tablet');
    }

    }
  });

document.addEventListener("DOMContentLoaded", function () {
  let discountButton = document.getElementById("apply-discount");
  let discountCode = discountButton.getAttribute("data-discount");
 if (discountButton) {

   function getCookie(name) {
    let cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      let parts = cookies[i].split("=");
      if (parts[0] === name) {
        return decodeURIComponent(parts[1]);
      }
    }
    return null;
  }

  function checkDiscount() {
    let discountFromCookie = getCookie("discount_code"); // Check Shopify's discount cookie
console.log('discountFromCookie',discountFromCookie)
    if (discountFromCookie == discountCode) {
      if (discountButton) {
        document.getElementById("apply-discount-main").style.display = "none"; // Hide discount div if applied
      }
    }
  }

  checkDiscount();
   
      discountButton.addEventListener("click", function () {
      
       console.log(discountCode);
      if (discountCode) {
         // Create an invisible iframe to trigger the discount session
        let iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = `/discount/${discountCode}`;

        document.body.appendChild(iframe);
        // Show success message
        let message = document.getElementById("discount-message");
        message.textContent = "Discount applied!";
        message.style.display = "block";
        document.getElementById("apply-discount-main").style.display = "none";
       
      }
    });
  }
});


